module.exports = __webpack_public_path__ + "img/gygx_04.011ad463.jpg";